import {CSSProperties} from '../../../styleSheet';
import {BasePaddingPxProps} from '../types';

export const buildPaddingStyle = ({
  padding,
  paddingHorizontal,
  paddingVertical,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
}: BasePaddingPxProps = {}): CSSProperties => {
  return {
    ...(padding ? {padding: `${padding}px`} : {}),
    ...(paddingHorizontal
      ? {
          paddingLeft: `${paddingHorizontal}px`,
          paddingRight: `${paddingHorizontal}px`,
        }
      : {}),
    ...(paddingVertical
      ? {
          paddingTop: `${paddingVertical}px`,
          paddingBottom: `${paddingVertical}px`,
        }
      : {}),
    ...(paddingTop ? {paddingTop: `${paddingTop}px`} : {}),
    ...(paddingBottom ? {paddingBottom: `${paddingBottom}px`} : {}),
    ...(paddingLeft ? {paddingLeft: `${paddingLeft}px`} : {}),
    ...(paddingRight ? {paddingRight: `${paddingRight}px`} : {}),
  };
};
